import { Box, Typography, TextField, Divider } from "@mui/material";
import { useState, useEffect, useRef } from "react";

const subCategories = [
  "Tea",
  "Food",
  "Petrol",
  "Stationary",
  "Poojai",
  "Printer",
  "Network",
  "Service charge",
  "Miscellaneous",
  "EB Bill",
  "Mobile Recharge",
  "Courier",
  "Post",
  "Water can",
  "Stamp paper",
];

const OfficeForm = ({ onChange, initialData, user }) => {
  const [rows, setRows] = useState([]);
  const inputsRef = useRef([]);

  const [meta, setMeta] = useState({
    employee_name: user?.name || "",
    emp_id: user?.id || "",
    date: new Date().toLocaleDateString(),
  });

  useEffect(() => {
    if (initialData?.rows) {
    setRows((initialData?.rows ?? []).filter(({ amount = 0 }) => Number(amount) > 0));
      // 🔥 IMPORTANT: LOAD META FROM DATA
      setMeta({
        employee_name: initialData.meta?.employee_name || user?.name,
        emp_id: initialData.meta?.emp_id || user?.id,
        date: initialData.meta?.date || new Date().toLocaleDateString(),
      });
    } else {
      setRows(
        subCategories.map((s) => ({
          sub_category: s,
          description: "",
          amount: "",
        })),
      );
    }
  }, [initialData]);

  useEffect(() => {
    const total = rows.reduce((s, r) => s + Number(r.amount || 0), 0);
    onChange({ rows, total, meta });
  }, [rows]);

  const update = (i, key, val) => {
    const copy = [...rows];
    copy[i][key] = val;
    setRows(copy);
  };

  // 🔥 ENTER / ARROW NAVIGATION
  const handleKeyDown = (e, rowIndex, field) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (field === "description") {
        inputsRef.current[rowIndex]?.amount?.focus();
      } else {
        inputsRef.current[rowIndex + 1]?.description?.focus();
      }
    }

    if (e.key === "ArrowDown") {
      inputsRef.current[rowIndex + 1]?.[field]?.focus();
    }

    if (e.key === "ArrowUp") {
      inputsRef.current[rowIndex - 1]?.[field]?.focus();
    }
  };

  const total = rows.reduce((s, r) => s + Number(r.amount || 0), 0);

  return (
    <Box>
      {/* TITLE */}
      <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 2 }}>
        Office Expenses
      </Typography>

      {/* META */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 2,
          mb: 2,
        }}
      >
        <TextField label="Employee Name" value={meta.employee_name} disabled />
        <TextField label="Employee ID" value={meta.emp_id} disabled />
        <TextField label="Date" value={meta.date} disabled />
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* 🔥 STICKY HEADER */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          display: "grid",
          gridTemplateColumns: "2fr 4fr 2fr",
          px: 2,
          py: 1.5,
          background: "#f4f6f8",
          borderBottom: "2px solid #ddd",
          fontWeight: 600,
        }}
      >
        <Typography>Sub Category</Typography>
        <Typography>Description</Typography>
        <Typography textAlign="right">Amount</Typography>
      </Box>

      {/* ROWS */}
      {rows
        ?.map((row, i) => (
          <Box
            key={i}
            sx={{
              display: "grid",
              gridTemplateColumns: "2fr 4fr 2fr",
              gap: 1,
              px: 2,
              py: 1.5,
              borderBottom: "1px solid #f0f0f0",
              "&:hover": { background: "#fafafa" },
            }}
          >
            <Typography>{row.sub_category}</Typography>

            {/* DESCRIPTION */}
            <TextField
              variant="standard"
              fullWidth
              value={row.description}
              inputRef={(el) => {
                if (!inputsRef.current[i]) inputsRef.current[i] = {};
                inputsRef.current[i].description = el;
              }}
              onKeyDown={(e) => handleKeyDown(e, i, "description")}
              onChange={(e) => update(i, "description", e.target.value)}
              error={!row.description && row.amount}
              placeholder="Enter description"
            />

            {/* AMOUNT */}
            <TextField
              variant="standard"
              type="number"
              value={row.amount}
              inputRef={(el) => {
                if (!inputsRef.current[i]) inputsRef.current[i] = {};
                inputsRef.current[i].amount = el;
              }}
              onKeyDown={(e) => handleKeyDown(e, i, "amount")}
              onChange={(e) => update(i, "amount", e.target.value)}
              inputProps={{ style: { textAlign: "right" } }}
              error={!row.amount && row.description}
              placeholder="0"
            />
          </Box>
        ))}

      {/* TOTAL */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "2fr 4fr 2fr",
          px: 2,
          py: 2,
          mt: 2,
          background: "#eef2ff",
          borderRadius: 2,
          border: "1px solid #dbeafe",
          fontWeight: 600,
        }}
      >
        <Typography>Total</Typography>
        <Box />
        <Typography textAlign="right">₹ {total}</Typography>
      </Box>
    </Box>
  );
};

export default OfficeForm;
